import axios from "axios";
import { Urls } from "../../../store/urls";

export const getHeaderDataRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_HEADER_API,
    params: data,
  });
};

export const getSubMenuRepo = () => {
  return axios({
    method: "GET",
    url: Urls.GET_SUBMENU_API,
  });
};

export const getTopCategoriesRepo = () => {
  return axios({
    method: "GET",
    url: Urls.GET_TOP_CATEGORIES,
  });
};

export const getLatestCategoryRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_LATEST_CATEGORY,
    params: data,
  });
};

export const getHomePageBannerRepo = () => {
  return axios({
    method: "GET",
    url: Urls.GET_HOMPAGE_BANNER_API,
  });
};

export const getHomePageSeoDataRepo = () => {
  return axios({
    method: "GET",
    url: Urls.GET_HOME_PAGE_DATA_SEO,
  });
};

export const getLocationRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_LOCATIONS_API,
    params: data,
  });
};

export const getRecommendedContentRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_CONTENT_RECOMMENDATIONS_API,
    params: data,
  });
};

export const postClearEntityCacheRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.POST_CLEAR_ENTITY_CACHE,
    params: data,
  });
};
